import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  width: ${({ width }) => (width ? width : 'auto')};
`;

export const SelectionButton = styled.button`
  padding: 9px 24px;
  background: #fff;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  border-radius: 4px;
  width: ${({ width }) => (width ? width : 'auto')};

  font-size: 14px;
  line-height: 20px;
  color: ${() => Palette.PrimaryGray._700};

  cursor: pointer;
  white-space: nowrap;

  transition: 0.1s ease-in-out;

  &:disabled {
    opacity: 0.8;
    pointer-events: none;
  }

  ${({ isBorderLeftRadiusNone }) =>
    isBorderLeftRadiusNone &&
    css`
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    `};

  ${({ isBorderRightRadiusNone }) =>
    isBorderRightRadiusNone &&
    css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `};

  &,
  &:hover,
  &:focus,
  &:active {
    outline: none;
  }

  &:hover {
    background: ${() => Palette.Primary._000};
    border: 1px solid ${() => Palette.PrimaryGray._200};
  }

  &:active,
  &:focus {
    background: ${() => Palette.Primary._000};
    box-shadow: ${({ isRadioButton }) =>
      isRadioButton ? 'none' : '0px 0px 0px 3px rgba(59, 137, 246, 0.16)'};
    border: 1px solid ${() => Palette.Primary._300};
  }

  ${({ isFirstItem, isRadioButton }) =>
    !isFirstItem &&
    isRadioButton &&
    css`
      border-left-color: transparent;
      &:hover {
        border-left-color: transparent;
      }
      &:active,
      &:focus {
        border-left-color: ${() => Palette.Primary._300};
      }
    `};

  ${({ isChecked }) =>
    isChecked &&
    css`
      background: ${() => Palette.Primary._000};
      border: 1px solid ${() => Palette.Primary._300};
      color: ${() => Palette.PrimaryGray._900};
      pointer-events: none;
    `};
`;
